import { useEffect } from 'react';
import { implementInstallerInHost, unmountCleanup } from './helperFunctions';
export const useInstallApp = essentials => {
  useEffect(() => unmountCleanup, []);
  return implementInstallerInHost(essentials);
};
//# sourceMappingURL=useInstallApp.js.map